import React from 'react';

/**
 *
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 *
 * Generic expanded-row layout: title + description on the left and any control
 * (switch, text field, ...) passed as children on the right.
 */
const ExpandedRowItem = ({
    title,
    description,
    className = '',
    children,
}) => {
    return (
        <div className={`row align-items-center justify-content-between ${className}`}>
            <div className='col-12 col-md-5 my-3'>
                <p className='font-color-general-950 fs-14px ibl-font-w-600 mb-3'>
                    {title}
                </p>
                <span className='font-color-general-950 ibl-font-w-400 fs-12px mt-3 text-break-wrap'>
                    {description}
                </span>
            </div>
           <div className={"col-12 col-md-5 my-3"}>
               {children}
           </div>
        </div>
    );
};

export default ExpandedRowItem;
